import { image, video } from '../../utils/helperQuery.wp';

export const heroHomeQuery = `
    ... on PageComponentsPageComponentsBlockHeroHomeLayout {
        fieldGroupName
        heading
        subheading
        description
        image {
            ${image}
        }
        video {
            ${video}
        }
        videoBackground {
            ${video}
        }
        heroImages {
            image {
                ${image}
            }
        }
    }
`;

// Homepage-hero video URL, fetched with the global (nav/footer) query so every
// page can warm the HLS before a client-side navigation to "/" — see
// components/utils/mediaPrefetch.js. `nodeByUri("/")` resolves the front page
// whatever its slug is, and only the one field the prefetcher needs is pulled,
// so this adds a few hundred bytes to a query that is already cached for 60s in
// _app.js.
export const heroHomeGlobalQuery = `
    homeNode: nodeByUri(uri: "/") {
        ... on Page {
            pageComponents {
                pageComponents {
                    ... on PageComponentsPageComponentsBlockHeroHomeLayout {
                        videoBackground {
                            node {
                                mediaItemUrl
                            }
                        }
                    }
                }
            }
        }
    }
`;
